import { z } from 'zod';

export const offerTypeEnum = z.enum([
  'personal_loan',
  'debt_consolidation', 
  'home_improvement',
  'auto_refinance',
  'credit_card_refinance',
  'emergency_fund'
]);

export const campaignVariantSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  
  // Personalization fields
  offerCode: z.string().optional(),
  firstName: z.string().optional(),
  offerAmount: z.number().min(1000).max(100000).optional(),
  offerType: offerTypeEnum.optional(),
  
  // UI Customizations
  headline: z.string().optional(),
  subheadline: z.string().optional(),
  ctaText: z.string().optional(),
  heroImage: z.string().url().optional(),
  
  // Form Defaults
  defaultLoanAmount: z.number().min(1000).max(100000).optional(),
  defaultLoanPurpose: z.string().optional(),
  
  // Styling
  primaryColor: z.string().optional(),
  secondaryColor: z.string().optional(),
  
  // Channel specific
  channel: z.string().optional(),
  source: z.string().optional(),
  medium: z.string().optional(),
  campaign: z.string().optional()
});

export type CampaignVariant = z.infer<typeof campaignVariantSchema>;
export type OfferType = z.infer<typeof offerTypeEnum>;

// Pre-defined campaign variants
export const defaultCampaignVariants: Record<string, CampaignVariant> = {
  default: {
    id: 'default',
    name: 'Default',
    defaultLoanAmount: 15000
  },
  
  debt_consolidation: {
    id: 'debt_consolidation',
    name: 'Debt Consolidation',
    offerType: 'debt_consolidation',
    defaultLoanAmount: 15000,
    defaultLoanPurpose: 'debt_consolidation',
    heroImage: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80'
  },
  
  home_improvement: {
    id: 'home_improvement', 
    name: 'Home Improvement',
    offerType: 'home_improvement',
    defaultLoanAmount: 25000,
    defaultLoanPurpose: 'home_improvement',
    heroImage: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80'
  },
  
  emergency_fund: {
    id: 'emergency_fund',
    name: 'Emergency Fund',
    offerType: 'emergency_fund',
    defaultLoanAmount: 8000,
    defaultLoanPurpose: 'emergency',
    heroImage: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80'
  },
  
  personalized: {
    id: 'personalized',
    name: 'Personalized Offer',
    defaultLoanAmount: 10000
  }
};